namespace Pages {
    export class AssortmentPage {
        private readonly _repository: RavenDbClient;

        constructor(repository: RavenDbClient) {
            this._repository = repository;
        }
        async index() {
            return new PageViewResult("Assortment/", {});
        }
        async inventory() {
            return new PageViewResult("Assortment/inventory", {});
        }

    }
}